import MedicaDecisionHistory from "./MedicaDecisionHistory";

export default MedicaDecisionHistory;
